/* eslint-disable @typescript-eslint/no-unused-vars */
import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';
import { RouteKeys } from './route-keys';

import SuspenseLoader from 'src/components/SuspenseLoader';
import AddNoteIndex from 'src/pages/common/AddNotes/AddNoteIndex';
import PdfRfqPreview from 'src/pages/PdfGeneration/PdfRfqPreview';
import PolicyProductsBrokerage from 'src/pages/PolicyProductsBrokerage';
import { element } from 'prop-types';
import EndoresementSubType from 'src/pages/EndoresementSubTypes';
import EndorsementList from 'src/pages/Endorsements/EndorsementList';
import EndorsementListView from 'src/pages/Endorsements/EndorsementListView';
import EndorsementListInsurerView from 'src/pages/Endorsements/EndorsementListInsurerView';
import EndorsementShareList from 'src/pages/Endorsements/EndorsementShareList';
import PolicyLod from 'src/pages/policyLod';
import PolicyClaimsList from 'src/pages/PolicyClaims/PolicyClaimsList';
import AssignSurveyorOtpView from 'src/pages/PolicyClaims/assignSurveyorOtpView';
import FormS from 'src/pages/reports/formS';
import EndorsementDraftShareList from 'src/pages/Endorsements/EndorsementDraftShareList';
import DocumentNames from 'src/pages/DocumentNames';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages

const Overview = Loader(lazy(() => import('src/pages/overview')));
const SessionExpired = Loader(lazy(() => import('src/pages/sessionExpired')));
// Dashboards

const Crypto = Loader(lazy(() => import('src/pages/dashboards')));
const EmployeeDashboards = Loader(
  lazy(() => import('src/pages/employeeDashboards'))
);
const SurveyorDashboards = Loader(
  lazy(() => import('src/pages/surveyorDashboards'))
);
const PolicyReports = Loader(
  lazy(() => import('src/pages/reports/policyReport/PolicyReports'))
);
const PolicyStatusReports = Loader(
  lazy(() => import('src/pages/reports/policyStatusReport'))
);
const PolicyRenewalReport = Loader(
  lazy(() => import('src/pages/reports/policyRenewalReport'))
);
const PolicyReport1 = Loader(
  lazy(() => import('src/pages/reports/policyReport1'))
);
const PolicyReport2 = Loader(
  lazy(() => import('src/pages/reports/policyReport2'))
);
const PlacementReports = Loader(
  lazy(() => import('src/pages/reports/placementReport'))
);
const PlacementReports2 = Loader(
  lazy(() => import('src/pages/reports/placementReport2'))
);

const RfqReports = Loader(
  lazy(() => import('src/pages/reports/RfqReports/RfqReports'))
);
// Applications
const Messenger1 = Loader(lazy(() => import('src/pages/Messenger1')));
const Messenger = Loader(lazy(() => import('src/pages/Messenger')));
const Users = Loader(lazy(() => import('src/pages/Usermanagement')));
const Calendar = Loader(lazy(() => import('src/pages/EventCalendar')));
const UserProfile = Loader(lazy(() => import('src/pages/Users/profile')));
const UserSettings = Loader(lazy(() => import('src/pages/Users/settings')));
const Branch = Loader(lazy(() => import('src/pages/Branch')));
const InsuranceClause = Loader(lazy(() => import('src/pages/InsuranceClause')));
const Feature = Loader(lazy(() => import('src/pages/Feature')));
const StaticForms = Loader(lazy(() => import('src/pages/StaticForms')));
const Permissions = Loader(lazy(() => import('src/pages/Permissions')));
const InsuranceComapny = Loader(
  lazy(() => import('src/pages/InsuranceCompany'))
);
const CorporateCustomers = Loader(
  lazy(() => import('src/pages/CorporateCustomers'))
);
const CorporateCustomersBranch = Loader(
  lazy(() => import('src/pages/CorporateCustomerBranch'))
);

const CorporateCustomersBankAccount = Loader(
  lazy(() => import('src/pages/CorporateCustomerBankAccount'))
);
const PresignedUrl = Loader(lazy(() => import('src/pages/PresignedUrl')));
const InsuranceType = Loader(lazy(() => import('src/pages/InsuranceCategory')));
const Customer = Loader(lazy(() => import('src/pages/Customer')));
const BranchContacts = Loader(lazy(() => import('src/pages/IcbContacts')));
const States = Loader(lazy(() => import('src/pages/state')));
const InsuranceCompanyBranchBankAccounts = Loader(
  lazy(() => import('src/pages/InsuranceCompanyBranchBankAccount'))
);
const InsuranceCompanyBranch = Loader(
  lazy(() => import('src/pages/InsuranceCompanyBranch'))
);
const InsuranceCompanyClause = Loader(
  lazy(() => import('src/pages/InsuranceCompanyClause'))
);
const Kudumbashree = Loader(lazy(() => import('src/pages/Kudumbashree')));
const ProductClauses = Loader(lazy(() => import('src/pages/ProductClauses')));
const RolePermissions = Loader(lazy(() => import('src/pages/RolePermissions')));
// const TaskList = Loader(lazy(() => import('src/pages/TasksList')));
const PolicyProduct = Loader(lazy(() => import('src/pages/PolicyProduct')));
const Enquiries = Loader(lazy(() => import('src/pages/Enquiries')));
const CompanyUsers = Loader(lazy(() => import('src/pages/CompanyUsers')));

const CustomerLeads = Loader(lazy(() => import('src/pages/CustomerLeads')));
const Zones = Loader(lazy(() => import('src/pages/Zone')));
const Grades = Loader(lazy(() => import('src/pages/Grades')));
const Gross = Loader(lazy(() => import('src/pages/Salary')));
// const Departments = Loader(lazy(() => import('src/pages/Departments')));
const Department = Loader(lazy(() => import('src/pages/Department')));
const MasterInputFields = Loader(
  lazy(() => import('src/pages/MasterInputFields'))
);
const EnquiryDetailing = Loader(
  lazy(() => import('src/pages/EnquiryDetailing'))
);
const TemplatePreview = Loader(
  lazy(() => import('src/pages/Forms/TemplatePreview'))
);
const Industry = Loader(lazy(() => import('src/pages/Industry')));
const Occupancy = Loader(lazy(() => import('src/pages/Occupancy')));
const InsuranceCategoryZone = Loader(
  lazy(() => import('src/pages/InsuranceCategoryZone'))
);
const MasterCategory = Loader(lazy(() => import('src/pages/MasterCategory')));
const InsuranceZone = Loader(lazy(() => import('src/pages/InsuranceZones')));
const ClientCompanyPremise = Loader(
  lazy(() => import('src/pages/ClientCompanyPremises'))
);

const CorporateCustomerPremise = Loader(
  lazy(() => import('src/pages/corporateCustomerPremises'))
);
const Currency = Loader(lazy(() => import('src/pages/Currency')));
const EmailMaster = Loader(
  lazy(() => import('src/pages/EmailMaster/EmailMasterIndex'))
);
const MachineType = Loader(lazy(() => import('src/pages/MachineType')));
const LinkExpiredPage = Loader(
  lazy(() => import('src/pages/common/LinkExpiredPage'))
);
const S3FileUpload = Loader(lazy(() => import('src/pages/S3FileUpload')));
const Status404 = Loader(lazy(() => import('src/pages/status/Status404')));
const Status500 = Loader(lazy(() => import('src/pages/status/Status500')));
const Logout = Loader(lazy(() => import('src/pages/status/Logout')));
const StatusComingSoon = Loader(
  lazy(() => import('src/pages/status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/pages/status/Maintenance'))
);
const NewsletterSettings = Loader(
  lazy(() => import('src/pages/NewsletterCategory'))
);
const Forms = Loader(lazy(() => import('src/pages/Forms')));
const Rfq = Loader(lazy(() => import('src/pages/Rfq')));

const Workflows = Loader(lazy(() => import('src/pages/Workflows')));
const WorkflowMapping = Loader(lazy(() => import('src/pages/WorkflowMapping')));
const Tasks = Loader(lazy(() => import('src/pages/Tasks')));
const Holidays = Loader(lazy(() => import('src/pages/HolidayList')));
const BlockIP = Loader(lazy(() => import('src/pages/BlockIP')));
const Stages = Loader(lazy(() => import('src/pages/Stages')));
const TaskView = Loader(lazy(() => import('src/pages/Tasks/taskView')));
const Requirements = Loader(lazy(() => import('src/pages/Requirements')));
// const RequestForQuotation = Loader(
//   lazy(() => import('src/pages/RequestForQuotation'))
// );
const RequirementView = Loader(
  lazy(() => import('src/pages/RfqGeneration/RequirementView'))
);
const Questionnaire = Loader(lazy(() => import('src/pages/Questionnaire')));
const Questions = Loader(lazy(() => import('src/pages/Questions')));

const Surveyor = Loader(lazy(() => import('src/pages/Surveyor')));
const RequirementTaskView = Loader(
  lazy(() => import('src/pages/RfqGeneration/RequirementTaskView'))
);
const EventLog = Loader(lazy(() => import('src/pages/EventLog')));
const MailLog = Loader(lazy(() => import('src/pages/MailLog')));
const CompanyRfqView = Loader(
  lazy(() => import('src/pages/CompanyRfq/CompanyRfqView'))
);

const RfqView = Loader(
  lazy(() => import('src/pages/Offers/RfqView/RfqViewPopup'))
);
const AnsweringQuestionnaireView = Loader(
  lazy(() => import('src/pages/Questionnaire/AnsweringQuestionnaireView'))
);
const PasswordReset = Loader(
  lazy(() => import('src/pages/auth/PasswordForgot'))
);

const WelcomeMailPasswordReset = Loader(
  lazy(() => import('src/pages/auth/WelcomeMailResetPassword'))
);
const ThirdPartyAdministrator = Loader(
  lazy(() => import('src/pages/ThirdPartyAdministrator'))
);
const TpaUser = Loader(lazy(() => import('src/pages/TpaUser')));
const TpaBranch = Loader(lazy(() => import('src/pages/TpaBranch')));
const TpaContacts = Loader(lazy(() => import('src/pages/TpaContacts')));
const District = Loader(lazy(() => import('src/pages/District')));
const Category = Loader(lazy(() => import('src/pages/Category')));
const Scores = Loader(lazy(() => import('src/pages/score')));
const Orders = Loader(lazy(() => import('src/pages/orders/Orders')));
const Policies = Loader(lazy(() => import('src/pages/policies/PoliciesList')));
const PolicyList = Loader(lazy(() => import('src/pages/policies')));
const PolicyRenewal = Loader(lazy(() => import('src/pages/PolicyRenewals')));
const Subcategory = Loader(lazy(() => import('src/pages/SubCategory')));
const Article = Loader(lazy(() => import('src/pages/Article')));
const RfqOld = Loader(lazy(() => import('src/pages/Rfq-old')));
const Offers = Loader(lazy(() => import('src/pages/Offers')));
const PlacementSlips = Loader(lazy(() => import('src/pages/PlacementSlips')));
const Wallet = Loader(lazy(() => import('src/pages/Wallet')));
const Placement = Loader(lazy(() => import('src/pages/Placement')));
const PlacementRfqDetails = Loader(
  lazy(() => import('src/pages/Placement/PlacementRfqDetails'))
);

const DynamicConfigurations = Loader(
  lazy(() => import('src/pages/DynamicConfigurations'))
);
const PolicyClaims = Loader(
  lazy(() => import('src/pages/Claims/InitiateCliam/PolicyClaimIndex'))
);
const PolicyClaimsQc = Loader(
  lazy(() => import('src/pages/Claims/policyClaimsQc'))
);
const ClaimTemplates = Loader(
  lazy(() => import('src/pages/Claims/ClaimTemplateBuilder/ClaimTemplateIndex'))
);

const QuestionnaireResponse = Loader(
  lazy(() => import('src/pages/QuestionnaireResponse'))
);
const Assessments = Loader(lazy(() => import('src/pages/Assessments')));

const RequirementClaimRequests = Loader(
  lazy(() => import('src/pages/ClaimRequests'))
);
const AssessmentsSummaryList = Loader(
  lazy(() => import('src/pages/AssessmentsSummaryList'))
);

const CompanyClaim = Loader(
  lazy(() => import('src/pages/CompanyClaim/OtpVerification'))
);
const PolicyClaimsReport = Loader(
  lazy(() => import('src/pages/reports/claimReport/ClaimReport'))
);

const AssessmentResponse = Loader(
  lazy(() => import('src/pages/AssessmentResponse'))
);
const RegistrationSuccess = Loader(
  lazy(() => import('src/pages/RegistrationSuccess'))
);
const ProductTemplate = Loader(
  lazy(() => import('src/pages/ProductTemplate/Index'))
);
const RfqForm = Loader(lazy(() => import('src/pages/Rfq/rfqForm/RfqForm')));
const HeaderManagement = Loader(
  lazy(() => import('src/pages/headerManagement/index'))
);
const Organogram = Loader(lazy(() => import('src/pages/Organogram')));
const Voyage = Loader(lazy(() => import('src/pages/Voyage')));
const VehichleType = Loader(lazy(() => import('src/pages/VehichleType')));
const ProductRate = Loader(lazy(() => import('src/pages/ProductRate')));
const Occupation = Loader(lazy(() => import('src/pages/Occupation')));
const AgeList = Loader(lazy(() => import('src/pages/AgeSettings')));
const SectionList = Loader(lazy(() => import('src/pages/SectionSettings')));
const OthersList = Loader(lazy(() => import('src/pages/OthersSettings')));
const QcApproval = Loader(lazy(() => import('src/pages/QcApproval')));
const RfqQcApproval = Loader(
  lazy(() => import('src/pages/QcApproval/rfqForm/RfqForm'))
);
const RFQEventLog = Loader(lazy(() => import('src/pages/Rfq/RFQEventLog')));
const RFQEventHistory = Loader(
  lazy(() => import('src/pages/Rfq/RFQHistory/RFQEventHistory'))
);

const EndoresementHistory = Loader(
  lazy(() => import('src/pages/Endorsements/History'))
);
const CreateOffer = Loader(lazy(() => import('src/pages/Offers/CreateOffer')));
const OfferConfirmation = Loader(
  lazy(() => import('src/pages/Offers/OfferConfirmation'))
);
const PlacementSlipOtpView = Loader(
  lazy(() => import('src/pages/PlacementSlips/PlacementSlipOtpView'))
);
const LorDocUploadOtpView = Loader(
  lazy(() => import('src/pages/PolicyClaims/lorDocUploadOtpView'))
);
const Banks = Loader(lazy(() => import('src/pages/Banks')));
const BranchesByBank = Loader(lazy(() => import('src/pages/Banks/Branches')));
const GeneratedOffers = Loader(
  lazy(() => import('src/pages/Offers/CreateOtpOffer/GeneratedOffers'))
);
const CustomerGroups = Loader(
  lazy(() => import('src/pages/customerGroup/index'))
);
const RfqCancelReason = Loader(
  lazy(() => import('src/pages/RfqCancelReasons'))
);
const VehicleMake = Loader(lazy(() => import('src/pages/VehichleMake')));
const VehicleModel = Loader(lazy(() => import('src/pages/VehichleModel')));
const VehicleVariant = Loader(lazy(() => import('src/pages/VehichleVariant')));
const CustomerLocation = Loader(
  lazy(() => import('src/pages/CustomerLocation'))
);
const Brokerage = Loader(
  lazy(() => import('src/pages/FinanceReports/invoice'))
);
const InvoicePayment = Loader(
  lazy(() => import('src/pages/FinanceReports/invoice/payment'))
);
const Reward = Loader(
  lazy(() => import('src/pages/FinanceReports/incentiveDistribution'))
);
const RewardPayment = Loader(
  lazy(() => import('src/pages/FinanceReports/incentiveDistribution/payment'))
);
const TDS = Loader(lazy(() => import('src/pages/FinanceReports/tds')));
const TaxPeriodSetting = Loader(
  lazy(() => import('src/pages/FinanceReports/taxPeriodSetting'))
);
const Tax = Loader(lazy(() => import('src/pages/FinanceReports/tax')));
const GeneratedInvoice = Loader(
  lazy(() => import('src/pages/FinanceReports/invoice/generatedInvoicefirst'))
);
const GeneratedRewardInvoice = Loader(
  lazy(
    () =>
      import(
        'src/pages/FinanceReports/incentiveDistribution/generatedRewardInvoice'
      )
  )
);
const MisReport = Loader(
  lazy(() => import('src/pages/reports/misReport/index'))
);
const MisReport1 = Loader(
  lazy(() => import('src/pages/reports/misReport1/index'))
);
const MisReport2 = Loader(
  lazy(() => import('src/pages/reports/misReport2/index'))
);
const LeadsReport = Loader(
  lazy(() => import('src/pages/reports/leadsReport/index'))
);
const InvoiceStatusReport = Loader(
  lazy(() => import('src/pages/reports/invoiceStatusReport/index'))
);
const InvoicingReport = Loader(
  lazy(() => import('src/pages/reports/invoicingReport/index'))
);

const InvoicingHistory = Loader(
  lazy(() => import('src/pages/FinanceReports/invoice/history'))
);
const RewardHistory = Loader(
  lazy(() => import('src/pages/FinanceReports/incentiveDistribution/history'))
);

const GeneratedInvoice2 = Loader(
  lazy(() => import('src/pages/FinanceReports/invoice/generatedInvoice2'))
);
const IrdaiForms = Loader(lazy(() => import('src/pages/reports/formS')));
const BrokerageReconciliation = Loader(
  lazy(() => import('src/pages/FinanceReports/brokerageReconciliation'))
);
const ExcessDeductible = Loader(
  lazy(() => import('src/pages/excessDeductible'))
);
const CoInsuranceList = Loader(
  lazy(() => import('src/pages/UpdateCoInsurance'))
);
const InvoiceReceivable = Loader(
  lazy(() => import('src/pages/reports/invoiceReceivable'))
);

const EndorsementStatusReport = Loader(
  lazy(() => import('src/pages/reports/endorsementReport'))
);

const InvoiceGstReport = Loader(
  lazy(() => import('src/pages/reports/invoiceGstReport'))
);
const TransactionWiseReceivableReport = Loader(
  lazy(() => import('src/pages/reports/transactionWiseReceivableReport'))
);
const BusinessReport = Loader(
  lazy(() => import('src/pages/reports/businessReport'))
);

const InsuranceCompanyWallet = Loader(
  lazy(() => import('src/pages/InsuranceCompanyWallet'))
);

const ClaimTpa = Loader(lazy(() => import('src/pages/ClaimTpa/ClaimTpandex')));
const ClaimSurveyor = Loader(
  lazy(() => import('src/pages/ClaimsSurveyor/SurveyorIndex'))
);
const ClaimSurveyorType = Loader(
  lazy(() => import('src/pages/ClaimsSurveyorType/SurveyorTypeIndex'))
);
const ClaimSubType = Loader(
  lazy(() => import('src/pages/ClaimSubType/ClaimSubTypeIndex'))
);
const Hospital = Loader(lazy(() => import('src/pages/Hospital/HospitalIndex')));
const RejectionReason = Loader(
  lazy(() => import('src/pages/RejectionReason/RejectionReasonIndex'))
);
const FieldMaster = Loader(
  lazy(() => import('src/pages/FieldMaster/FieldMasterIndex'))
);
const MasterData = Loader(
  lazy(() => import('src/pages/MasterData/MasterDataIndex'))
);
const BusinessBRReport = Loader(
  lazy(() => import('src/pages/reports/businessBRReport'))
);
const BrokerageAdjustmentEndorsement = Loader(
  lazy(() => import('src/pages/FinanceReports/adjustmentBrokerageEndorsement'))
);
const routes = (isLoggedIn) => [
  {
    path: '/',
    element: isLoggedIn ? <SidebarLayout /> : <Navigate to="/login" />
  },
  {
    path: '/dashboards',
    element: isLoggedIn ? <SidebarLayout /> : <Navigate to="/login" />,
    children: [
      { element: <Navigate to="/dashboards/dashboard" replace /> },

      {
        path: RouteKeys.Home,
        element: <Navigate to={RouteKeys.CryptoDashboard} replace />
      },
      {
        path: 'dashboard',
        element: <Crypto />
      },
      {
        path: RouteKeys.RfqEventLog,
        element: <RFQEventLog />
      },
      {
        path: RouteKeys.RfqEventHistory,
        element: <RFQEventHistory />
      },
      {
        path: RouteKeys.EndoresementHistory,
        element: <EndoresementHistory />
      },
      {
        path: RouteKeys.Occupation,
        element: <Occupation />
      },
      {
        path: RouteKeys.AgeSettingsList,
        element: <AgeList />
      },
      {
        path: RouteKeys.SectionSettingsList,
        element: <SectionList />
      },
      {
        path: RouteKeys.OthersSettingsList,
        element: <OthersList />
      },
      {
        path: RouteKeys.ProductRate,
        element: <ProductRate />
      },
      {
        path: RouteKeys.EmployeeDashboard,
        element: <EmployeeDashboards />
      },
      {
        path: RouteKeys.SurveyorDashboard,
        element: <SurveyorDashboards />
      },
      {
        path: RouteKeys.Messenger,
        element: <Messenger1 />
      },
      {
        path: RouteKeys.Messenger1,
        element: <Messenger />
      },
      {
        path: RouteKeys.Details,
        element: <UserProfile />
      },
      {
        path: RouteKeys.Settings,
        element: <UserSettings />
      },
      {
        path: RouteKeys.Branch,
        element: <Branch />
      },
      {
        path: RouteKeys.RfqCancelReason,
        element: <RfqCancelReason />
      },
      {
        path: RouteKeys.Users,
        element: <Users />
      },
      {
        path: RouteKeys.Leads,
        element: <CustomerLeads />
      },
      {
        path: RouteKeys.InsuranceType,
        element: <InsuranceType />
      },
      {
        path: RouteKeys.Feature,
        element: <Feature />
      },
      {
        path: RouteKeys.StaticForms,
        element: <StaticForms />
      },
      {
        path: RouteKeys.Users,
        element: <Users />
      },
      {
        path: RouteKeys.InsuranceClause,
        element: <InsuranceClause />
      },
      {
        path: RouteKeys.InsuranceComapny,
        element: <InsuranceComapny />
      },
      {
        path: RouteKeys.PresignedUrl,
        element: <PresignedUrl />
      },
      {
        path: RouteKeys.InsuranceCompanyBranch,
        element: <InsuranceCompanyBranch />
      },
      {
        path: RouteKeys.InsuranceCompanyClause,
        element: <InsuranceCompanyClause />
      },
      {
        path: RouteKeys.InsuranceCompanyBranchBankAccount,
        element: <InsuranceCompanyBranchBankAccounts />
      },

      {
        path: RouteKeys.Permissions,
        element: <Permissions />
      },
      {
        path: RouteKeys.InsuranceClause,
        element: <InsuranceClause />
      },
      {
        path: RouteKeys.IcbContacts,
        element: <BranchContacts />
      },
      {
        path: 'rolePermissions',
        element: <RolePermissions />
      },

      {
        path: RouteKeys.PolicyProducts,
        element: <PolicyProduct />
      },
      {
        path: RouteKeys.PolicyLod,
        element: <PolicyLod />
      },
      {
        path: RouteKeys.PolicyProductsBrokerage,
        element: <PolicyProductsBrokerage />
      },
      {
        path: RouteKeys.Kudumbashree,
        element: <Kudumbashree />
      },
      {
        path: RouteKeys.Customer,
        element: <Customer />
      },
      {
        path: RouteKeys.ProductClauses,
        element: <ProductClauses />
      },

      {
        path: RouteKeys.CorporateCustomers,
        element: <CorporateCustomers />
      },
      {
        path: RouteKeys.CorporateCustomersBranch,
        element: <CorporateCustomersBranch />
      },
      {
        path: RouteKeys.CorporateCustomersBankAccount,
        element: <CorporateCustomersBankAccount />
      },
      {
        path: RouteKeys.CorporateCustomerPremise,
        element: <CorporateCustomerPremise />
      },
      {
        path: RouteKeys.Zones,
        element: <Zones />
      },
      {
        path: RouteKeys.Grades,
        element: <Grades />
      },
      {
        path: RouteKeys.Gross,
        element: <Gross />
      },
      {
        path: RouteKeys.Enquiries,
        element: <Enquiries />
      },
      {
        path: RouteKeys.Requirements,
        element: <Requirements />
      },
      {
        path: RouteKeys.CompanyUsers,
        element: <CompanyUsers />
      },
      {
        path: RouteKeys.Department,
        element: <Department />
      },
      {
        path: RouteKeys.MasterInputFields,
        element: <MasterInputFields />
      },
      {
        path: RouteKeys.EnquiryDetailing,
        element: <EnquiryDetailing />
      },

      {
        path: RouteKeys.S3FileUpload,
        element: <S3FileUpload />
      },
      {
        path: RouteKeys.Industry,
        element: <Industry />
      },
      {
        path: RouteKeys.Occupancy,
        element: <Occupancy />
      },
      {
        path: RouteKeys.InsuranceCategoryZone,
        element: <InsuranceCategoryZone />
      },
      {
        path: RouteKeys.Master,
        element: <MasterCategory />
      },
      {
        path: RouteKeys.InsuranceZone,
        element: <InsuranceZone />
      },
      {
        path: RouteKeys.ClientCompanyPremise,
        element: <ClientCompanyPremise />
      },

      {
        path: RouteKeys.Wallet,
        element: <Wallet />
      },
      {
        path: RouteKeys.ReailCustWallet,
        element: <Wallet />
      },
      {
        path: RouteKeys.TemplatePreview,
        element: <TemplatePreview />
      },

      {
        path: RouteKeys.NewsletterSettings,
        element: <NewsletterSettings />
      },
      {
        path: RouteKeys.DocumentNames,
        element: <DocumentNames />
      },
      {
        path: RouteKeys.Forms,
        element: <Forms />
      },
      {
        path: RouteKeys.Workflows,
        element: <Workflows />
      },
      {
        path: RouteKeys.WorkflowMapping,
        element: <WorkflowMapping />
      },
      {
        path: RouteKeys.Tasks,
        element: <Tasks />
      },
      {
        path: RouteKeys.Holidays,
        element: <Holidays />
      },
      {
        path: RouteKeys.BlockIP,
        element: <BlockIP />
      },
      {
        path: RouteKeys.Currency,
        element: <Currency />
      },
      {
        path: RouteKeys.EmailMaster,
        element: <EmailMaster />
      },

      {
        path: RouteKeys.Rfq,
        element: <Rfq />,
        children: [
          { element: <Navigate to="/dashboards/dashboard" replace /> },

          {
            path: RouteKeys.RfqView,
            element: <Rfq />
          }
        ]
      },

      {
        path: RouteKeys.EventCalendar,
        element: <Calendar />
      },
      {
        path: RouteKeys.RequirementNotes,
        element: <AddNoteIndex />
      },
      {
        path: RouteKeys.TaskNotes,
        element: <AddNoteIndex />
      },
      {
        path: RouteKeys.EventLog,
        element: <EventLog />
      },
      {
        path: RouteKeys.MailLog,
        element: <MailLog />
      },
      {
        path: RouteKeys.ThirdPartyAdministrator,
        element: <ThirdPartyAdministrator />
      },
      {
        path: RouteKeys.TpaUser,
        element: <TpaUser />
      },
      {
        path: RouteKeys.TpaBranch,
        element: <TpaBranch />
      },
      {
        path: RouteKeys.Stages,
        element: <Stages />
      },
      {
        path: RouteKeys.TpaContact,
        element: <TpaContacts />
      },
      {
        path: RouteKeys.Category,
        element: <Category />
      },
      {
        path: RouteKeys.EndoresementSubTypes,
        element: <EndoresementSubType />
      },
      {
        path: RouteKeys.Subcategory,
        element: <Subcategory />
      },
      {
        path: RouteKeys.Article,
        element: <Article />
      },
      {
        path: RouteKeys.TpaContact,
        element: <TpaContacts />
      },
      {
        path: RouteKeys.Scores,
        element: <Scores />
      },
      {
        path: RouteKeys.Orders,
        element: <Orders />
      },
      // {
      //   path: RouteKeys.Policies,
      //   element: <Policies />
      // },
      {
        path: RouteKeys.States,
        element: <States />
      },
      {
        path: RouteKeys.District,
        element: <District />
      },
      {
        path: RouteKeys.PolicyReports,
        element: <PolicyReports />
      },
      {
        path: RouteKeys.RfqReports,
        element: <RfqReports />
      },
      {
        path: RouteKeys.RequestForQuotation,
        element: <Rfq />
      },

      {
        path: RouteKeys.Offers,
        element: <Offers />
      },
      {
        path: RouteKeys.PlacementSlip,
        element: <PlacementSlips />
      },
      {
        path: RouteKeys.UpdateCoInsurance,
        element: <CoInsuranceList />
      },
      {
        path: RouteKeys.Policies,
        element: <PolicyList />
      },
      {
        path: RouteKeys.Endorsement,
        element: <EndorsementList />
      },
      {
        path: RouteKeys.EndorsementShareList,
        element: <EndorsementShareList />
      },
      {
        path: RouteKeys.EndorsementDraftShareList,
        element: <EndorsementDraftShareList />
      },
      {
        path: RouteKeys.PolicyRenewal,
        element: <PolicyRenewal />
      },
      {
        path: RouteKeys.DynamicConfigurations,
        element: <DynamicConfigurations />
      },
      {
        path: RouteKeys.Surveyor,
        element: <Surveyor />
      },
      {
        path: RouteKeys.Bank,
        element: <Banks />
      },
      {
        path: RouteKeys.BranchByBank,
        element: <BranchesByBank />
      },
      {
        path: RouteKeys.PolicyClaims,
        element: <PolicyClaims />
      },
      {
        path: RouteKeys.PolicyClaimsQC,
        element: <PolicyClaimsQc />
      },
      {
        path: RouteKeys.ClaimTemplates,
        element: <ClaimTemplates />
      },
      {
        path: RouteKeys.RequirementClaimRequests,
        element: <RequirementClaimRequests />
      },
      {
        path: RouteKeys.Logout,
        element: <Logout />
      },
      {
        path: RouteKeys.Questions,
        element: <Questions />
      },
      {
        path: RouteKeys.Questionnaire,
        element: <Questionnaire />
      },
      {
        path: RouteKeys.QuestionnaireResponse,
        element: <QuestionnaireResponse />
      },
      {
        path: RouteKeys.Assessments,
        element: <Assessments />
      },
      {
        path: RouteKeys.AssessmentsSummaryList,
        element: <AssessmentsSummaryList />
      },
      {
        path: RouteKeys.AssessmentsResponse,
        element: <AssessmentResponse />
      },
      {
        path: RouteKeys.PolicyClaimsReport,
        element: <PolicyClaimsReport />
      },
      {
        path: RouteKeys.RegistrationSuccess,
        element: <RegistrationSuccess />
      },
      {
        path: RouteKeys.policyProductsTemplate,
        element: <ProductTemplate />
      },
      // {
      //   path: RouteKeys.CreateRfq,
      //   element: <CreateRfq />
      // },
      {
        path: RouteKeys.headerManagement,
        element: <HeaderManagement />
      },
      {
        path: RouteKeys.Organogram,
        element: <Organogram />
      },
      {
        path: RouteKeys.MachineType,
        element: <MachineType />
      },
      {
        path: RouteKeys.Voyage,
        element: <Voyage />
      },
      {
        path: RouteKeys.VehichleType,
        element: <VehichleType />
      },
      {
        path: RouteKeys.QcApproval,
        element: <QcApproval />
      },
      {
        path: RouteKeys.Placement,
        element: <Placement />
      },
      {
        path: RouteKeys.RfqDetails,
        element: <PlacementRfqDetails />
      },
      {
        path: RouteKeys.CustomerGroup,
        element: <CustomerGroups />
      },
      {
        path: RouteKeys.VehicleMake,
        element: <VehicleMake />
      },
      {
        path: RouteKeys.VehicleModel,
        element: <VehicleModel />
      },
      {
        path: RouteKeys.VehicleVariant,
        element: <VehicleVariant />
      },
      {
        path: RouteKeys.CustomerLocation,
        element: <CustomerLocation />
      },
      {
        path: RouteKeys.Brokerage,
        element: <Brokerage />
      },
      {
        path: RouteKeys.PolicyStatusReport,
        element: <PolicyStatusReports />
      },
      {
        path: RouteKeys.PolicyRenewalReport,
        element: <PolicyRenewalReport />
      },
      {
        path: RouteKeys.PolicyReportOne,
        element: <PolicyReport1 />
      },
      {
        path: RouteKeys.PolicyReportTwo,
        element: <PolicyReport2 />
      },
      {
        path: RouteKeys.PlacementReport,
        element: <PlacementReports />
      },
      {
        path: RouteKeys.PlacementReportTwo,
        element: <PlacementReports2 />
      },
      {
        path: RouteKeys.InvoicePayment,
        element: <InvoicePayment />
      },
      {
        path: RouteKeys.Reward,
        element: <Reward />
      },
      {
        path: RouteKeys.RewardPayment,
        element: <RewardPayment />
      },
      {
        path: RouteKeys.TaxPeriodSetting,
        element: <TaxPeriodSetting />
      },
      {
        path: RouteKeys.TDS,
        element: <TDS />
      },
      {
        path: RouteKeys.Tax,
        element: <Tax />
      },
      {
        path: RouteKeys.GeneratedInvoice,
        element: <GeneratedInvoice />
      },
      {
        path: RouteKeys.GeneratedRewardInvoice,
        element: <GeneratedRewardInvoice />
      },
      {
        path: RouteKeys.MisReport,
        element: <MisReport />
      },
      {
        path: RouteKeys.MisReport1,
        element: <MisReport1 />
      },
      {
        path: RouteKeys.MisReport2,
        element: <MisReport2 />
      },
      {
        path: RouteKeys.LeadsReport,
        element: <LeadsReport />
      },
      {
        path: RouteKeys.InvoiceStatusReport,
        element: <InvoiceStatusReport />
      },
      {
        path: RouteKeys.InvoicingReport,
        element: <InvoicingReport />
      },

      {
        path: RouteKeys.InvoicingHistory,
        element: <InvoicingHistory />
      },
      {
        path: RouteKeys.RewardHistory,
        element: <RewardHistory />
      },
      {
        path: RouteKeys.GenerateInvoice2,
        element: <GeneratedInvoice2 />
      },
      {
        path: RouteKeys.IrdaiForms,
        element: <IrdaiForms />
      },
      {
        path: RouteKeys.BrokerageReconciliation,
        element: <BrokerageReconciliation />
      },
      {
        path: RouteKeys.ExcessDeductible,
        element: <ExcessDeductible />
      },
      { path: RouteKeys.InvoiceReceivable, element: <InvoiceReceivable /> },
      {
        path: RouteKeys.EndorsementStatusReport,
        element: <EndorsementStatusReport />
      },
      { path: RouteKeys.InvoiceGstReport, element: <InvoiceGstReport /> },
      {
        path: RouteKeys.TransactionWiseReceivableReport,
        element: <TransactionWiseReceivableReport />
      },
      {
        path: RouteKeys.BusinessReport,
        element: <BusinessReport />
      },
      {
        path: RouteKeys.InsuranceCompanyWallet,
        element: <InsuranceCompanyWallet />
      },
      {
        path: RouteKeys.ClaimTpa,
        element: <ClaimTpa />
      },
      {
        path: RouteKeys.ClaimSurveyor,
        element: <ClaimSurveyor />
      },
      {
        path: RouteKeys.ClaimSurveyorType,
        element: <ClaimSurveyorType />
      },
      {
        path: RouteKeys.ClaimSubType,
        element: <ClaimSubType />
      },
      {
        path: RouteKeys.RejectionReason,
        element: <RejectionReason />
      },
      {
        path: RouteKeys.Hospital,
        element: <Hospital />
      },
      {
        path: RouteKeys.FieldMaster,
        element: <FieldMaster />
      },
      {
        path: RouteKeys.MasterData,
        element: <MasterData />
      },
      {
        path: RouteKeys.BusinessBRReport,
        element: <BusinessBRReport />
      },
      {
        path: RouteKeys.BrokerageAdjustmentEndorsement,
        element: <BrokerageAdjustmentEndorsement />
      }
    ]
  },
  {
    path: '/dashboards',
    element: isLoggedIn ? <BaseLayout /> : <Navigate to="/login" />,
    children: [
      {
        path: RouteKeys.CreateRFQ,
        element: <RfqForm />
      },

      {
        path: RouteKeys.RfqQcApproval,
        element: <RfqQcApproval />
      },
      {
        path: RouteKeys.CreateOffer,
        element: <CreateOffer />
      }
      // {
      //   path: RouteKeys.RequirementView,
      //   element: <RequirementView />
      // },
      // {
      //   path: RouteKeys.RequirementTaskView,
      //   element: <RequirementTaskView />
      // }
    ]
  },
  {
    path: '/otp-verification/*',
    element: <CompanyRfqView />
  },
  {
    path: RouteKeys.EndorsementLists,
    element: <EndorsementListView />
  },
  {
    path: RouteKeys.EndorsementInsurerLists,
    element: <EndorsementListInsurerView />
  },

  {
    path: '/generatedOffers/*',
    element: <GeneratedOffers />
  },

  {
    path: '/viewRfq/*',
    element: <RfqView />
  },
  {
    path: '/offer-confirmation/*',
    element: <OfferConfirmation />
  },
  {
    path: '/pacement-slip-view/*',
    element: <PlacementSlipOtpView />
  },
  {
    path: '/claims-otpVerification/*',
    element: <AssignSurveyorOtpView />
  },
  {
    path: '/lor-otpVerification/*',
    element: <LorDocUploadOtpView />
  },
  {
    path: '/answeringQuestionnaire/*',
    element: <AnsweringQuestionnaireView />
  },
  { path: RouteKeys.PasswordReset, element: <PasswordReset /> },
  {
    path: RouteKeys.WelcomeMailPasswordReset,
    element: <WelcomeMailPasswordReset />
  },

  {
    path: '/claim-otp-verification/*',
    element: <CompanyClaim />
  },
  {
    path: '/rfq-pdf-generation/*',
    element: <PdfRfqPreview />
  },
  { path: RouteKeys.SessionExpired, element: <SessionExpired /> },
  {
    path: '/404',
    element: <Status404 />
  },
  {
    path: '/link-expired',
    element: <LinkExpiredPage />
  },
  {
    path: '/',
    element: !isLoggedIn ? (
      <BaseLayout />
    ) : (
      <Navigate to="/dashboards/dashboard" />
    ),
    children: [
      { path: 'login', element: <Overview /> },

      { path: RouteKeys.PasswordReset, element: <PasswordReset /> },
      // {
      //   path: RouteKeys.WelcomeMailPasswordReset,
      //   element: <WelcomeMailPasswordReset />
      // },

      {
        path: 'otp-verification/*',
        element: <CompanyRfqView />
      },

      {
        path: 'answeringQuestionnaire/*',
        element: <AnsweringQuestionnaireView />
      },
      {
        path: RouteKeys.Overview,
        element: <Navigate to={RouteKeys.Home} replace />
      },
      {
        path: RouteKeys.StatusPath,
        children: [
          {
            path: RouteKeys.Home,
            element: <Navigate to={RouteKeys.NotFound} replace />
          },
          {
            path: RouteKeys.NotFound,
            element: <Status404 />
          },
          {
            path: RouteKeys.NotFoundStatus,
            element: <Status500 />
          },
          {
            path: RouteKeys.Maintenance,
            element: <StatusMaintenance />
          },
          {
            path: RouteKeys.ComingSoon,
            element: <StatusComingSoon />
          }
        ]
      }
    ]
  },
  { path: '*', element: <Navigate to="/404" replace /> }
];
export default routes;
